import applyDirectoryFilter from './applyDirectoryFilter';
import getFeaturedPublishers from './getFeaturedPublishers';
import getWhatshotPublishers from './getWhatshotPublishers';
import getPopularNowPublishers from './getPopularNowPublishers';
import getNearMePublishers from './getNearMePublishers';
import getDirectoryPublishers from './getDirectoryPublishers';
import loadMoreDirectoryPublishers from './loadMoreDirectoryPublishers';
import searchDirectoryPublishers from './searchDirectoryPublishers';
import loadMoreSearchResults from './loadMoreSearchResults';
import getRecommendedPublishers from './getRecommendedPublishers';
import getTotalSubscribers from './getTotalSubscribers';
import getWidgetParamsMap from './getWidgetParamsMap';
import initPublisherData from './initPublisherData';
import setSearchText from './search/setSearchText';
import setWhatshotEnabled from './search/setWhatshotEnabled';
import toggleIndustryFilter from './search/toggleIndustryFilter';
import clearIndustryFilters from './search/clearIndustryFilters';

const actions = {
    applyDirectoryFilter,
    getFeaturedPublishers,
    getWhatshotPublishers,
    getPopularNowPublishers,
    getNearMePublishers,
    getDirectoryPublishers,
    loadMoreDirectoryPublishers,
    searchDirectoryPublishers,
    loadMoreSearchResults,
    getRecommendedPublishers,
    getTotalSubscribers,
    getWidgetParamsMap,
    initPublisherData,
    setSearchText,
    setWhatshotEnabled,
    toggleIndustryFilter,
    clearIndustryFilters,
};

export default actions;
